import { Button } from "react-bootstrap";
import { FaUpload, FaTimes } from "react-icons/fa";

export const FilesInput = ({
  files,
  onFileUpload,
  onRemoveFile,
  namePrefix = "files",
  style = {},
}) => {
  return (
    <div style={style}>
      <h6 className="d-flex align-items-center gap-2 mb-2">
        <FaUpload /> Project Files
      </h6>
      {files.length > 0 && (
        <div className="mb-2">
          <div
            className="border rounded"
            style={{ maxHeight: "110px", overflowY: "auto" }}
          >
            {files.map((file, index) => (
              <div
                key={index}
                className="d-flex align-items-center justify-content-between p-2 border-bottom gap-2"
              >
                <span className="small text-truncate">
                  {file instanceof File ? file.name : file.name || file}
                </span>
                <Button
                  variant="link"
                  size="sm"
                  onClick={() => onRemoveFile(index)}
                  className="p-0 text-danger"
                  title="Remove file"
                >
                  <FaTimes style={{ fontSize: "10px" }} />
                </Button>
              </div>
            ))}
          </div>
        </div>
      )}
      <div
        className="border border-2 rounded p-2 text-center bg-light"
        style={{ borderStyle: "dashed", cursor: "pointer" }}
        onClick={() => document.getElementById(`${namePrefix}-upload`).click()}
      >
        <input
          id={`${namePrefix}-upload`}
          type="file"
          multiple
          onChange={onFileUpload}
          className="d-none"
        />
        <div className="d-flex flex-row gap-2 align-items-center justify-content-center">
          <FaUpload className="text-secondary" style={{ fontSize: "20px" }} />
          <p className="mb-0 text-muted small">Click to upload files</p>
        </div>
      </div>
    </div>
  );
};
